import { Alert, Box, HStack, VStack, useToast } from 'native-base';

export const useCleaningToast = () => {
  const toast = useToast();

  const showToast = (status: 'success' | 'error', content: React.ReactNode) =>
    toast.show({
      placement: 'bottom',
      duration: 1500,
      render: () => (
        <Alert maxWidth="100%" alignSelf="center" flexDirection="row" status={status} bg="gray.900">
          <VStack space={1} flexShrink={1} w="100%">
            <HStack space={2} flexShrink={1} alignItems="center">
              <Alert.Icon size="md" />
              <Box>{content}</Box>
            </HStack>
          </VStack>
        </Alert>
      ),
    });

  return { showToast };
};
